// CookieHandler.ts

export interface CookieOptions {
    expires?: string;
    path?: string;
}

export function addValueToCookie(key: string, value: string): void {
    const currentValue = getCookie(key) || '';
    const updatedValue = `${currentValue},${value}`;
    setCookie(key, updatedValue);
}

export function isValueInCookie(key: string, value: string): boolean {
    const cookieValue = getCookie(key) || '';
    const values = cookieValue.split(',');
    return values.includes(value);
}

export function getCookie(key: string): string | undefined {
    const cookiePairs = document.cookie.split(';').map(pair => pair.trim().split('='));
    const cookieObj: Record<string, string> = Object.fromEntries(cookiePairs);
    return cookieObj[key];
}

export function setCookie(key: string, value: string, options?: CookieOptions): void {
    const { expires, path } = options || {};
    // console.log(expires, path);
    // console.log(value);
    document.cookie = `${key}=${value}${expires !== undefined ? `; expires=${expires}` : '; expires=Fri, 31 Dec 9999 23:59:59 GMT'}${path !== undefined ? `; path=${path}` : '/'}`;
}

// document.cookie = `_popUpCancelledId=${data.id}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;

